const PaySuccessIcon = ({ width = 32, height = 32, color = '#DA291C' }) => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="5214"
      width={width}
      height={height}>
      <path
        d="M512 908.816c-219.152 0-396.8-177.648-396.8-396.8 0-219.152 177.648-396.8 396.8-396.8 219.152 0 396.8 177.648 396.8 396.8 0 219.152-177.648 396.8-396.8 396.8z m0 51.2c247.424 0 448-200.576 448-448s-200.576-448-448-448-448 200.576-448 448 200.576 448 448 448z"
        fill={color}
        p-id="5215"></path>
      <path
        d="M464 688.016a48 48 0 1 0 96 0 48 48 0 0 0-96 0z m24-112h48c4.4 0 8-3.6 8-8v-272c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
        fill={color}
        p-id="5216"></path>
    </svg>
  )
}

export default PaySuccessIcon
